
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/news-archive/[post]",
      function () {
        return require("private-next-pages/inspiration/news-archive/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/news-archive/[post]"])
      });
    }
  